(function () {
  'use strict';

  const EVENT_COOLDOWN = 5000;

  const lastFired = {};

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)')
    );

    return match
      ? decodeURIComponent(match[1])
      : null;
  }

  function getParam(name) {
    const params = new URLSearchParams(window.location.search);

    return params.get(name);
  }

  function log(type, message, data) {
    console.group(
      `%c[EdgeTag ${type}]`,
      'color:#8B5CF6;font-weight:bold;'
    );

    console.log(message);

    if (data) {
      console.log(data);
    }

    console.groupEnd();
  }

  function canFire(eventName) {
    const now = Date.now();

    if (
      lastFired[eventName] &&
      now - lastFired[eventName] < EVENT_COOLDOWN
    ) {
      log(
        'BLOCKED',
        'Duplicate event prevented',
        {
          event: eventName
        }
      );

      return false;
    }

    lastFired[eventName] = now;

    return true;
  }

  function addDefaultProps(props, el) {
    props = props || {};

    props.page_path =
      window.location.pathname;

    props.page_url =
      window.location.href;

    props.referrer =
      document.referrer || null;

    props.user_agent =
      navigator.userAgent || null;

    props.element_text =
      el && el.innerText
        ? el.innerText.trim()
        : null;

    props.element_href =
      el && el.href
        ? el.href
        : null;

    props.fbp =
      getCookie('_fbp');

    props.fbc =
      getCookie('_fbc');

    props.ttp =
      getCookie('_ttp');

    props.ga =
      getCookie('_ga');

    props.gcl_au =
      getCookie('_gcl_au');

    props.utm_source =
      getParam('utm_source');

    props.utm_medium =
      getParam('utm_medium');

    props.utm_campaign =
      getParam('utm_campaign');

    props.utm_content =
      getParam('utm_content');

    props.utm_term =
      getParam('utm_term');

    props.event_source =
      'browser';

    props.event_timestamp =
      new Date().toISOString();

    return props;
  }

  function fire(eventName, props, el, cooldownKey) {
    if (!eventName) {
      return;
    }

    if (!canFire(cooldownKey || eventName)) {
      return;
    }

    props = addDefaultProps(props || {}, el || null);

    try {
      if (typeof window.edgetag !== 'function') {
        log(
          'ERROR',
          'window.edgetag not found',
          {
            event: eventName,
            props: props
          }
        );

        return;
      }

      const payload = {
        event: eventName,
        props: props,
        timestamp: new Date().toISOString()
      };

      log(
        'SEND',
        'Sending EdgeTag Event',
        payload
      );

      window.edgetag(
        'tag',
        eventName,
        props
      );

    log(
  'SUCCESS',
  'EdgeTag request dispatched successfully. Check Network tab for confirmation.',
  payload
);

    } catch (err) {
      log(
        'ERROR',
        'EdgeTag Failed',
        {
          event: eventName,
          props: props,
          error: err
        }
      );
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const el = event.target.closest(
        '[data-edgetag-event]'
      );

      if (!el) {
        return;
      }

      const eventName =
        el.getAttribute('data-edgetag-event');

      let props = {};

      const rawProps =
        el.getAttribute('data-edgetag-props');

      if (rawProps) {
        try {
          props = JSON.parse(rawProps);
        } catch (err) {
          log(
            'ERROR',
            'Invalid JSON in data-edgetag-props',
            {
              rawProps: rawProps,
              error: err
            }
          );
        }
      }

      log(
        'CLICK',
        'Tracked Element Clicked',
        {
          event: eventName,
          props: props,
          element: el
        }
      );

      fire(eventName, props, el);
    },
    true
  );

  window.IRedgetag = {
    // options.cooldownKey (optional): key the 5 s duplicate guard on this
    // instead of the event name, for callers that already know each call is
    // a separate shopper action (e.g. sections/quiz-lp-hero.liquid).
    fire: function (eventName, props, options) {
      fire(eventName, props || {}, null, options && options.cooldownKey);
    }
  };

  log(
    'INIT',
    'EdgeTag Tracking Library Loaded'
  );
})();